'use client'

import { Card, SimpleGrid, Text, Title, Tooltip } from '@mantine/core'
import Image from 'next/image'
import { useState } from 'react'
//@ts-ignore
import AutomatedIcon from '../../../../../assets/AutomatedIc.png'
//@ts-ignore
import ManualIcon from '../../../../../assets/UploadIc.png'
import ManualVerificationForm from './ManualVerificationForm'

export const ChooseKyc = () => {
  const [step, setStep] = useState<'choose' | 'manualForm' | 'manualChecklist'>(
    'choose',
  )

  return (
    <div className='min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-white to-gray-100 py-12 px-4'>
      {step === 'choose' && (
        <>
          <Title order={2} fw={600} size='30px' c='#101828' mb={8}>
            KYC Verification
          </Title>

          <Text size='14px' fw={500} c='#696F7A' mb={50}>
            Choose your preferred verification method
          </Text>

          <SimpleGrid
            cols={{ base: 1, md: 2 }}
            spacing='lg'
            className='max-w-3xl w-full'
          >
            {/* Manual Verification */}
            <Card
              shadow='sm'
              radius='lg'
              padding='xl'
              withBorder
              className='flex flex-col items-center text-center cursor-pointer hover:shadow-md transition'
              onClick={() => setStep('manualForm')}
            >
              <Image
                src={ManualIcon}
                alt='Manual Verification Icon'
                width={28}
                height={28}
                className='mb-3'
              />

              <Text
                className='mb-2'
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: '#16181C',
                  marginTop: 10,
                }}
              >
                Manual Verification
              </Text>

              <Text
                style={{
                  fontSize: 13,
                  fontWeight: 400,
                  color: '#696F7A',
                  lineHeight: '22px',
                  marginTop: 6,
                }}
              >
                Upload your documents manually.
                <br />
                Estimated time: 5–10 minutes
              </Text>
            </Card>

            {/* Automated Verification */}
            <Tooltip label='Coming soon' withArrow position='bottom'>
              <div style={{ pointerEvents: 'none' }}>
                <Card
                  shadow='sm'
                  radius='lg'
                  padding='xl'
                  withBorder
                  className='flex flex-col items-center text-center transition'
                  style={{
                    opacity: 0.5,
                    cursor: 'not-allowed',
                    pointerEvents: 'auto',
                  }}
                >
                  <Image
                    src={AutomatedIcon}
                    alt='Automated Verification Icon'
                    width={28}
                    height={28}
                    className='mb-3'
                  />

                  <Text
                    className='mb-2'
                    style={{
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#16181C',
                      marginTop: 10,
                    }}
                  >
                    Automated Verification
                  </Text>

                  <Text
                    style={{
                      fontSize: 13,
                      fontWeight: 400,
                      color: '#696F7A',
                      lineHeight: '22px',
                      marginTop: 6,
                    }}
                  >
                    Scan QR code with your phone.
                    <br />
                    Estimated time: 2–3 minutes
                  </Text>
                </Card>
              </div>
            </Tooltip>
          </SimpleGrid>
        </>
      )}

      {step === 'manualForm' && (
        <ManualVerificationForm onComplete={() => setStep('manualChecklist')} />
      )}
    </div>
  )
}
